import Snowpiercer from '@jusbrasil/snowpiercer'

export const snowpiercerClient = new Snowpiercer()
